import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Image from "../../components/image";
import { _ } from "../../utils/i18n";

const ImageDiv = styled.div`
  position: relative;
  background-color: var(--color-white);
  text-align: center;
  & div:first-child {
    height: 350px;
  }
`;
const SaleBadge = styled.div`
  display: flex;
  width: 100%;
  position: absolute;
  top: 0;
  justify-content: ${({ $saleBadgeAlign }) =>
    $saleBadgeAlign === "left"
      ? "flex-start"
      : $saleBadgeAlign === "center"
      ? "center"
      : "flex-end"};
`;

const Badge = styled.div`
  border: 1px solid var(--color-black);
  border-radius: var(--border-radius);
  background-color: var(--color-white);
  color: var(--color-black);
  text-transform: uppercase;
  padding: 5px 10px;
`;

const ProductImage = ({ image, showSaleBadge, saleBadgeAlign }) => {
  return (
    <ImageDiv>
      <Image image={image} objectFit="contain" />
      {showSaleBadge ? (
        <SaleBadge $saleBadgeAlign={saleBadgeAlign}>
          <Badge>{_("Salg")}</Badge>
        </SaleBadge>
      ) : null}
    </ImageDiv>
  );
};

ProductImage.propTypes = {
  image: PropTypes.object,
  showSaleBadge: PropTypes.bool,
  saleBadgeAlign: PropTypes.string,
};

export default ProductImage;
